import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance.js";
import Pagination from "../../common/Pagination/index.js";
import Loader from "../../common/Loader/index.js";
import { BiSolidEditAlt } from "react-icons/bi";
import { MdClose, MdDeleteForever } from "react-icons/md";
import Model from "../../common/Model/index.js";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { notify, Toast } from "../../common/Toast/index.js";
import FormFields from "../../common/FormFields/index.js";
import { getEntityFields } from "../../utlis/entityConfig.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";

const Fabricator = () => {
  const permission = getUserMenuPermission(3);
  const [isFabricatorData, setIsFabricatorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    fabricator_ID: 0,
    name: "",
    contactNo: "",
    email: "",
    firmName: "",
    officeAddress: "",
  });
  const userId = sessionStorage.getItem("userId");

  const fetchFabricatorData = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(
        `Fabricator/GetAll/?pageNumber=${currentPage}&pageSize=${pageSize}`,
        {
          pageNumber: currentPage,
          pageSize,
          fabricatorId: 0,
        }
      );
      setIsFabricatorData(res.data.fabricators);
      setFilteredData(res.data.fabricators);
      setTotalRecords(res.data.totalRecords);
      setTotalPages(
        res.data.fabricators?.length < pageSize ? currentPage : currentPage + 1
      );
    } catch (err) {
      console.error("Error fetching data:", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFabricatorData();
  }, [currentPage]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddFebricator = () => {
    if (!permission.isInsert) {
      notify("You don't have permission to add Fabricator.", "error");
      return;
    }
    setFormData({
      fabricator_ID: "",
      name: "",
      contactNo: "",
      email: "",
      firmName: "",
      officeAddress: "",
    });
    setIsEditing(false);
    setIsModelOpen(true);
  };

  const handleEditFebricator = async (id) => {
    try {
      const { data } = await axiosInstance.get(`Fabricator/GetById/${id}`);
      if (data) {
        setFormData({
          fabricator_ID: data.fabricator_ID || "",
          name: data.fabricator_Name || "",
          contactNo: data.contact_No || "",
          email: data.email_ID || "",
          firmName: data.firm_Name || "",
          officeAddress: data.office_Address || "",
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (err) {
      notify("Error fetching Fabricator data:", err);
    }
  };

  const handleDeleteFebricator = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(`Fabricator/Delete/${selectedId}`);
      fetchFabricatorData();
      notify("Fabricator deleted successfully!", "error");
    } catch (err) {
      notify("Failed to delete Fabricator!", "error");
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEditing && !permission.isInsert) return;
    if (isEditing && !permission.isUpdate) return;
    try {
      const payload = {
        Contact_No: formData.contactNo,
        Email_ID: formData.email,
        Firm_Name: formData.firmName,
        Fabricator_Name: formData.name,
        Office_Address: formData.officeAddress,
        Fabricator_ID: formData.fabricator_ID
          ? parseInt(formData.fabricator_ID, 10)
          : 0,
        Created_By: userId,
        UpdatedBy: userId,
      };

      await axiosInstance.post("Fabricator/SaveUpdate", payload);
      fetchFabricatorData();
      setIsModelOpen(false);
      notify(
        isEditing
          ? "Fabricator updated successfully!"
          : "Fabricator added successfully!",
        "success"
      );
    } catch (err) {
      notify("Error submitting form:", "error");
    }
  };

  const fetchFilteredFebricator = async (query) => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        `Fabricator/FilterByName?fabricatorName=${query}`
      );
      setFilteredData(res.data);
      setTotalRecords(res.data.length);
    } catch (err) {
      notify("Error fetching filtered data", "error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (searchQuery.trim() === "") {
      fetchFabricatorData();
    } else {
      fetchFilteredFebricator(searchQuery);
    }
  }, [searchQuery, currentPage]);

  const clearSearch = () => {
    setSearchQuery("");
    fetchFabricatorData();
  };
  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary">
              <LiaSearchPlusSolid className="w-5 h-5" />
            </button>
            {searchQuery && (
              <button
                onClick={clearSearch}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              >
                <MdClose className="w-5 h-5" />
              </button>
            )}
          </div>
          {permission.isInsert && (
            <button
              className="bg-primary rounded px-4 text-white py-2"
              onClick={handleAddFebricator}
            >
              + Add Febricator
            </button>
          )}
        </div>

        {loading ? (
          <Loader />
        ) : permission.isView ? (
          <div className="overflow-x-auto rounded-lg">
            <table className="w-full min-w-[700px] text-sm text-left border border-gray rounded-lg">
              <thead className="bg-primary text-white tracking-widest text-center font-light">
                <tr>
                  <th className="border border-gray-400 px-4 py-3 whitespace-nowrap">
                    Name
                  </th>
                  <th className="border border-gray-400 px-4 py-3 whitespace-nowrap">
                    Contact
                  </th>
                  <th className="border border-gray-400 px-4 py-3 whitespace-nowrap">
                    Email
                  </th>
                  <th className="border border-gray-400 px-4 py-3 whitespace-nowrap">
                    Firm
                  </th>
                  <th className="border border-gray-400 px-4 py-3 whitespace-nowrap">
                    Address
                  </th>
                  <th
                    className={`${
                      !permission.isUpdate && !permission.isDelete
                        ? "hidden"
                        : ""
                    } border border-gray-400 px-4 py-3 whitespace-nowrap`}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.length > 0 ? (
                  filteredData.map((fabricator) => (
                    <tr
                      key={fabricator.fabricator_ID}
                      className="border-b hover:bg-gray-50 transition cursor-pointer text-center"
                    >
                      <td className="border border-gray-100 px-4 py-2">
                        {fabricator.fabricator_Name}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {fabricator.contact_No}
                      </td>
                      <td className="border border-gray-100 px-4 py-2 truncate">
                        {fabricator.email_ID}
                      </td>
                      <td className="border border-gray-100 px-4 py-2">
                        {fabricator.firm_Name}
                      </td>
                      <td className="border border-gray-100 px-4 py-2 max-w-[150px]">
                        {fabricator.office_Address}
                      </td>

                      {(permission.isUpdate || permission.isDelete) && (
                        <td className="py-3 border border-gray-100 text-center space-x-2">
                          {permission.isDelete && (
                            <button
                              className="bg-red-100 text-red-600 hover:bg-red-200 px-2 py-1 rounded-md"
                              onClick={() =>
                                handleDeleteFebricator(fabricator.fabricator_ID)
                              }
                            >
                              <MdDeleteForever className="w-5 h-5" />
                            </button>
                          )}
                          {permission.isUpdate && (
                            <button
                              className="bg-[#e3f2fd] text-primary hover:bg-blue-200 px-2 py-1 rounded-md"
                              onClick={() =>
                                handleEditFebricator(fabricator.fabricator_ID)
                              }
                            >
                              <BiSolidEditAlt className="w-5 h-5" />
                            </button>
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-4">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-red-500 text-lg py-10">
            You don't have permission to view this page.
          </div>
        )}

        <div className="flex justify-between items-center">
          <p className="text-sm text-gray-6">
            Showing {isFabricatorData?.length + (currentPage - 1) * 10} of{" "}
            {totalRecords} records
          </p>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>
      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Fabricator" : "Add Fabricator"}
      >
        <FormFields
          onSubmit={handleSubmit}
          setIsModelOpen={setIsModelOpen}
          formData={formData}
          handleInputChange={handleInputChange}
          fields={getEntityFields("fabricator")}
          onClear={() => setIsModelOpen(false)}
          isEditing={isEditing}
        />
      </Model>
      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-4 text-center">
          <p className="text-lg font-semibold mb-4">
            Are you sure you want to delete this site?
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-gray-5 px-4 py-2 rounded-md"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="bg-danger text-white px-4 py-2 rounded-md"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default Fabricator;
